import axios from 'helpers/axios';

export const getChipCurrencies = async () => {
    const { data } = await axios.get('/api/adminapi/chipcurrencies/');

    return data;
};
